import theme from '~/theme/';

type ContentWrapperProps = {
  field?: any;
  questionInfo?: any;
  children?: React.ReactNode;
  hasBottomBorder?: boolean;
  isVisible?: boolean;
  padding?: string | number;
  testId?: string;
  id?: string;
  flex?: string;
  hasTopBorder?: boolean;
};

/**
 * @typedef {object} ContentWrapperProps
 * @property {boolean} hasBottomBorder - If the content wrapper should have a bottom border.
 * @property {React.ReactNode} children - The children to be rendered.
 *
 * @param {ContentWrapperProps} props
 * @returns {JSX.Element}
 */
export default function ContentWrapper({
  hasBottomBorder = true,
  hasTopBorder,
  padding = '1rem 0 0.25rem 0',
  isVisible = true,
  testId = 'content-wrapper',
  id = 'content-wrapper',
  flex,
  children,
}: Readonly<ContentWrapperProps>) {
  const borderStyle = `1px solid ${theme.colors?.gray[200]}`;
  const borderBottom = hasBottomBorder ? borderStyle : 'none';

  const borderTop = hasTopBorder ? borderStyle : 'none';

  return (
    <div
      style={{
        borderBottom,
        borderTop,
        padding: padding,
        display: isVisible ? 'block' : 'none',
        flex,
      }}
      data-testid={testId}
      id={id}
    >
      {children}
    </div>
  );
}
